import React from 'react';
import { Box, Typography, Autocomplete, TextField } from '@mui/material';
import OsFilterSelector from './OsFilterSelector';

type Props = {
  selectedApp: string | null;
  appOptions: string[];                         // 실제 옵션 리스트 (ex. ['앱 전체', '하루날씨', ...])
  onAppChange: (app: string | null) => void;    // '전체' 또는 clear → null
  onSearch?: (selectedApp: string | null) => void; // 선택 사항 (검색 버튼 없음)
  selectedOs?: string;                          // 지정 시 OS 토글(ALL/AOS/IOS)이 함께 표시됨
  onOsChange?: (os: string) => void;
};

export default function FilterSelectorWithApp({
  selectedApp,
  appOptions,
  onAppChange,
  selectedOs,
  onOsChange,
}: Props) {
  const displayOptions = [...appOptions.filter(o => o !== '전체')];

  return (
    <Box
      sx={{
        p: 2.5,
        borderRadius: 3,
        bgcolor: '#ffffff',
        maxWidth: selectedOs !== undefined ? 760 : 640,
        width: '100%',
        height: { xs: 'auto', md: 125 },
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.04)',
        border: '1px solid #f1f5f9',
      }}
    >
      <Typography
        variant="subtitle1"
        fontWeight={600}
        mb={2}
        color="#475569"
        sx={{ fontSize: '0.95rem' }}
      >
        필터 설정
      </Typography>

      <Box
        sx={{
          display: 'flex',
          gap: 2,
          flexDirection: { xs: 'column', md: 'row' },
          alignItems: { xs: 'stretch', md: 'center' },
        }}
      >
        <Autocomplete<string, false, false, false>
          options={displayOptions}
          value={selectedApp ?? null}
          onChange={(_, v) => onAppChange(v === '전체' ? null : v)}
          isOptionEqualToValue={(opt, val) => opt === val}
          clearOnEscape
          sx={{ width: { xs: '100%', md: 320 } }}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder="앱을 선택하세요"
              variant="outlined"
              size="small"
              sx={{
                bgcolor: '#f8fafc',
                borderRadius: 2.5,
                '& .MuiOutlinedInput-root': {
                  '& fieldset': {
                    borderColor: '#e2e8f0',
                  },
                  '&:hover fieldset': {
                    borderColor: '#cbd5e1',
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: '#0044D2',
                  },
                },
              }}
            />
          )}
        />

        {selectedOs !== undefined && onOsChange && (
          <OsFilterSelector selectedOs={selectedOs} onChange={onOsChange} />
        )}
      </Box>
    </Box>
  );
}
